var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLockOutlineCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2073 14.8125H11.7925C11.2075 14.8125 10.7333 15.2602 10.7333 15.8125V19.3125C10.7333 19.8648 11.2075 20.3125 11.7925 20.3125H19.2073C19.7924 20.3125 20.2666 19.8648 20.2666 19.3125V15.8125C20.2666 15.2602 19.7924 14.8125 19.2073 14.8125Z",
    stroke: "#3872D4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9333 14.8125V12.9792C12.9333 12.3714 13.2038 11.7885 13.6851 11.3587C14.1665 10.9289 14.8193 10.6875 15.5 10.6875C16.1807 10.6875 16.8336 10.9289 17.3149 11.3587C17.7963 11.7885 18.0667 12.3714 18.0667 12.9792V14.8125",
    stroke: "#3872D4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15,
    stroke: "#6C6E88"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLockOutlineCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lock-outline-circle.cfd43612047ed6c13476c070c22189fa.svg";